import { Check, ErrorOutline, WarningAmberOutlined } from '@mui/icons-material'
import { defaultTheme } from 'src/theme'
import { ValidationTag } from '../Common/interfaces'

interface TagInfo {
  color: string
  background: string
  label: string
  description?: string
  shortDescription?: string
  icon: JSX.Element
}

export const getTagInfo = (type: ValidationTag): TagInfo => {
  const { red, primary, green } = defaultTheme.colors
  const { invalidTag, duplicateTag, validTag } = defaultTheme.colors
  const iconStyle = { width: '20px', height: '20px' }

  switch (type) {
    case ValidationTag.INVALID:
      return {
        color: red,
        background: invalidTag,
        label: ValidationTag.INVALID,
        description: 'weWereUnableToFindThisItemInOurDatabase',
        shortDescription: 'thisItemWasNotFoundInOurDatabase',
        icon: <ErrorOutline style={iconStyle} />,
      }
    case ValidationTag.DUPLICATE:
      return {
        color: primary,
        background: duplicateTag,
        label: ValidationTag.DUPLICATE,
        description:
          'moreThanOneItemWasFoundWithMatchingPartNumbersFromDifferentManufacturers',
        shortDescription: 'duplicateItemsFoundWithMatchingPartNumbers',
        icon: <WarningAmberOutlined style={iconStyle} />,
      }
    default:
      return {
        color: green,
        background: validTag,
        label: ValidationTag.VALID,
        icon: <Check style={iconStyle} />,
      }
  }
}
